import React, { Component } from 'react';
import ClosedDeals from "../Components/ClosedDeals";
import IntlMessages from 'util/IntlMessages';
export default class AvslutadeAffärer extends Component {
    render() {
        return (
            <div className="text-center potition-relative" style={{ color: 'white', height: 'calc(100% - 12px)', paddingBottom: 20, overflow: 'hidden' }}>
                <div className="d-flex justify-content-center row" style={{ marginTop: '12px' }}>
                    <h2 className="col" style={{fontWeight:"500",color:this.props.FontColor}}><b><IntlMessages id="DashBoard.Deal.Closed"/></b></h2>
                 {/*   <div style={{ marginTop: '-14px', marginRight:'10px' }}>
                        <CustomMenu />
                    </div>*/}
                </div>
                <div className="d-flex justify-content-center" style={{height: 'calc(100% - 50px)'}}>
                    <ClosedDeals intervaltype={this.props.intervaltype} FontColor={this.props.FontColor}/>
                </div>
                <div className="d-flex justify-content-end w-100" style={{position: 'absolute', bottom: 4, right: 16,color:this.props.FontColor}}>
                    <p>{this.props.getIntervalTypeText(this.props.intervaltype)}</p>
                </div>
            </div>
        )
    }
}
